<template>
  <b-modal
    :active.sync="active_"
    has-modal-card
    class="schedular-form-modal"
    @close="close"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">
          {{ task ? "Update" : "Create" }} Task
        </p>
      </header>
      <section class="modal-card-body">
        <!-- <b-field label="Order Create Day">
          <b-datetimepicker
            v-model="form.order_create_day"
            horizontal-time-picker
            icon="calendar"
            :datetime-formatter="dateTimeFormatter"
          />
        </b-field> -->
        <base-select
          v-model="form.order_type"
          name="select_order_type"
          :service="$options.codeService"
          fetch-func="all"
          :fetch-params="{
            type: 'orderType',
            contract_id: contract ? contract.id : undefined,
          }"
          label="Order Type"
          @input:manual="onInputOrderType"
        />
        <base-select
          v-model="form.order_subtype"
          name="select_sub_type"
          :service="$options.codeService"
          fetch-func="chained"
          :fetch-params="{
            ids: [form.order_type],
            type: 'activityType',
            contract_id: contract ? contract.id : undefined,
          }"
          :fetch-on-init="false"
          label="Sub Type"
          :disabled="!form.order_type"
          @input:manual="onInputSubType"
          ref="selectSubtype"
        />
        <base-select
          v-model="form.priority"
          name="select_priority"
          :service="$options.codeService"
          fetch-func="childIntersection"
          :fetch-params="{
            ids: [form.order_type, form.order_subtype],
            type: 'orderPriority',
            contract_id: contract ? contract.id : undefined,
          }"
          :fetch-on-init="false"
          value-key="name"
          label="Priority"
          :disabled="!form.order_subtype"
          ref="selectPriority"
        />
        <b-field label="Order Description">
          <b-input v-model="form.order_description" type="textarea"></b-input>
        </b-field>
        <!-- <base-select
          v-model="form.tag"
          :service="$options.tagService"
          fetch-func="all"
          :fetch-params="{
            type: '[ORDER][MANDATORY]',
            firm_id: contract ? contract.contractee_firm_id : undefined,
          }"
          label="Tag"
        ></base-select> -->
        <base-tag-input
          :value.sync="form.tags"
          :fetch-params="{
            type: '[ORDER][MANDATORY]',
          }"
          open-on-focus
          allow-new
        />
        <b-field label="Operation Description">
          <b-input v-model="form.operation_description" type="textarea"></b-input>
        </b-field>
        <base-select
          v-model="form.activity_code"
          name="select_activity"
          :service="$options.codeService"
          fetch-func="chained"
          :fetch-params="{
            ids: [form.order_type, form.order_subtype],
            type: 'ACTIVITY',
            contract_id: contract ? contract.id : undefined,
          }"
          :fetch-on-init="false"
          value-key="code"
          label="Activity"
          :disabled="!form.order_subtype"
          @input:manual="onInputActivity"
          @change="
            (option) => (form.activity_code_id = option ? option.id : '')
          "
          ref="selectActivity"
        />
        <base-select
          v-model="form.asset_type"
          name="select_asset_type"
          :service="$options.codeService"
          fetch-func="chained"
          :fetch-params="{
            ids: [form.order_type, form.order_subtype, form.activity_code_id],
            type: 'ASSET',
            contract_id: contract ? contract.id : undefined,
          }"
          :fetch-on-init="false"
          value-key="code"
          label="Asset Type"
          :disabled="!form.activity_code"
          ref="selectAssetType"
        />
        <b-field label="Parent Asset Code">
          <b-input v-model="form.parent_asset_code"></b-input>
        </b-field>
        <b-field label="Asset Code">
          <b-input v-model="form.asset_code"></b-input>
        </b-field>
        <base-select
          v-model="form.failure_code_id"
          name="select_failure"
          :service="$options.codeService"
          fetch-func="childIntersection"
          :fetch-params="{
            ids: [form.order_type, form.order_subtype],
            type: 'FAILURE',
            contract_id: contract ? contract.id : undefined,
          }"
          :fetch-on-init="false"
          label="Default Failure Code"
          :disabled="!form.order_type || !form.order_subtype"
          ref="selectFailure"
        />
        <base-select
          v-model="form.repair_code_id"
          name="select_repair"
          :service="$options.codeService"
          fetch-func="childIntersection"
          :fetch-params="{
            ids: [form.order_type, form.order_subtype],
            type: 'REPAIR',
            contract_id: contract ? contract.id : undefined,
          }"
          :fetch-on-init="false"
          label="Default Repair Code"
          :disabled="!form.order_type || !form.order_subtype"
          ref="selectRepair"
        />
        <base-select
          v-model="form.rate_code"
          name="select_rate"
          :service="$options.orderOperationClaimService"
          fetch-func="all"
          :fetch-params="{
            contract_id: contract ? contract.id : undefined,
            code_ids: [
              form.order_type,
              form.order_subtype,
              form.activity_code_id,
            ],
            status: 1,
          }"
          :fetch-on-init="false"
          value-key="code"
          label="Rate"
          :disabled="!form.activity_code"
          ref="selectRate"
        >
          <template #customLabel="{ option }">
            {{ `${option.ninaCode} ${option.description}` }}
          </template>
        </base-select>
        <b-field label="Frequency">
          <b-select v-model="form.frequency" expanded>
            <option value>Please Select</option>
            <option
              v-for="option in $options.frequencies"
              :value="option"
              :key="option"
            >
              {{ option }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Next Date">
          <b-datepicker
            v-model="form.next_date"
            icon="calendar"
            :date-formatter="dateFormatter"
            class="datepicker-next_date"
          />
        </b-field>
        <b-field label="End Date">
          <b-datepicker
            v-model="form.end_date"
            icon="calendar"
            :date-formatter="dateFormatter"
            class="datepicker-end_date"
          />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">Cancel</b-button>
        <b-button :loading="loading" @click.prevent="submitForm">
          Save
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import BaseTagInput from "@/components/partials/BaseTagInput";
import { CodeService } from "@/services/code.service";
import { ContractService } from "@/services/contract.service";
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { TagService } from "@/services/tag.service";
import { datepickerMixin } from "@/mixins/datepickerMixin";

export default {
  codeService: CodeService,
  contractService: ContractService,
  orderOperationClaimService: OrderOperationClaimServiceService,
  tagService: TagService,
  frequencies: [
    "DAILY",
    "WEEKLY",
    "FORTNIGHTLY",
    "MONTHLY",
    "QUARTERLY",
    "ANNUALLY",
    "BIENNIALLY",
    "2-WEEKLY",
    "2-MONTHLY",
    "3-MONTHLY",
    "4-MONTHLY",
    "6-MONTHLY",
    "2-YEARLY",
    "3-YEARLY",
    "4-YEARLY",
    "5-YEARLY",
  ],
  mixins: [datepickerMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    contract: {
      type: Object,
    },
    task: {
      type: Object,
    },
  },
  components: {
    BaseSelect,
    BaseTagInput,
  },
  data: () => ({
    active_: false,
    form: {
      // order_create_day: new Date(),
      order_type: "",
      order_subtype: "",
      priority: "",
      order_description: "",
      // tag: "",
      tags: [],
      operation_description: "",
      activity_code: "",
      activity_code_id: "",
      asset_type: "",
      parent_asset_code: "",
      asset_code: "",
      failure_code_id: "",
      repair_code_id: "",
      rate_code: "",
      frequency: "",
      next_date: new Date(),
      end_date: null,
    },
    loading: false,
  }),
  watch: {
    active(active) {
      this.active_ = active;
    },
    active_(active) {
      if (active) {
        this.setForm();
      } else {
        this.clearForm();
      }
      this.$emit("update:active", active);
    },
    "form.order_type"() {
      this.$nextTick(() => {
        if (this.form.order_type) {
          this.$refs.selectSubtype.fetchOptions();
        }
      });
    },
    "form.order_subtype"() {
      this.$nextTick(() => {
        this.$refs.selectPriority.fetchOptions();
        this.$refs.selectActivity.fetchOptions();
        if (this.form.order_type && this.form.order_subtype) {
          this.$refs.selectFailure.fetchOptions();
          this.$refs.selectRepair.fetchOptions();
        }
      });
    },
    "form.activity_code"() {
      this.$nextTick(() => {
        this.$refs.selectAssetType.fetchOptions();
        this.$refs.selectRate.fetchOptions();
      });
    },
  },
  methods: {
    setForm() {
      if (this.task) {
        this.form = {
          // order_create_day: new Date(this.task.order_create_day),
          order_type: this.task.order_type || "",
          order_subtype: this.task.order_subtype || "",
          priority: this.task.priority || "",
          order_description: this.task.headerLog.data.order_description || "",
          // tag: this.task.order_tag_id || "",
          tags: (this.task.tags || []).map(v => v.name),
          operation_description: this.task.description || "",
          activity_code: this.task.activityCode
            ? this.task.activityCode.code
            : "",
          activity_code_id: this.task.activity_code_id || "",
          asset_type: this.task.assetCode ? this.task.assetCode.code : "",
          parent_asset_code: this.task.parentAsset
            ? this.task.parentAsset.thirdPartyCode
            : "",
          asset_code: this.task.asset ? this.task.asset.thirdPartyCode : "",
          failure_code_id: this.task.failure_code_id || "",
          repair_code_id: this.task.repair_code_id || "",
          // rate_code: this.task.rate ? this.task.rate.code : "",
          rate_code: this.task.rate_code || "",
          frequency: this.task.frequency,
          next_date: new Date(this.task.next_date),
          end_date: this.task.end_date ? new Date(this.task.end_date) : "",
        };
      }
    },
    clearForm() {
      this.form = {
        // order_create_day: new Date(),
        order_type: "",
        order_subtype: "",
        priority: "",
        order_description: "",
        // tag: "",
        tags: [],
        operation_description: "",
        activity_code: "",
        activity_code_id: "",
        asset_type: "",
        parent_asset_code: "",
        asset_code: "",
        failure_code_id: "",
        repair_code_id: "",
        rate_code: "",
        frequency: "",
        next_date: new Date(),
        end_date: null,
      };
    },
    close() {
      this.clearForm();
      this.$emit("close");
      this.active_ = false;
    },
    async submitForm() {
      this.$emit("submit", {
        ...this.form,
        next_date: this.dateParser(this.form.next_date),
        end_date: this.form.end_date
          ? this.dateParser(this.form.end_date)
          : null,
      });
    },
    // Manual input event handlers
    onInputOrderType() {
      this.form.order_subtype = "";
    },
    onInputSubType() {
      this.form.priority = "";
      this.form.activity_code = "";
    },
    onInputActivity() {
      this.form.asset_type = "";
      this.form.rate_code = "";
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Schedular/SchedularFormModal.vue